import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText,
    Dropdown,
    Modal,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input

} from 'reactstrap';
import "../../layout.css"
import { useLocation, useNavigate } from 'react-router-dom';
import { MdMenu, MdCheckCircle } from 'react-icons/md';
import apiRequest from '../../../api';


const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen)
    const [dropDownOpen, setDropDownOpen] = useState(false)
    const toggleDropdown = () => setDropDownOpen(!dropDownOpen);
    const { pathname } = useLocation()
    const [modalOpen, setModalOpen] = useState(false)
    const toggleModal = () => {
        if (isOpen === false) {
            setFormDetails({
                email: sessionStorage.getItem("email"),
                oldpassword: "",
                newpassword: "",
            });
            setErrors({
                email: "",
                oldpassword: "",
                newpassword: "",
            })
        }

        setModalOpen(!modalOpen);

    };

    const [formDetails, setFormDetails] = useState({
        email: sessionStorage.getItem("email"),
        oldpassword: "",
        newpassword: "",
    });
    const [errors, setErrors] = useState({
        email: "",
        oldpassword: "",
        newpassword: "",
    });
    const username = sessionStorage.getItem("username");
    const [emailChangeSuccess, setEmailChangeSuccess] = useState(false);

    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return localStorage.getItem('Language') || 'EN';
    });
    useEffect(() => {
        localStorage.setItem('Language', selectedLanguage);
        window.dispatchEvent(new CustomEvent('languageChange', {
            detail: { selectedLanguage }
        }));
    }, [selectedLanguage]);
    const [selectedEmailLanguage, setSelectedEmailLanguage] = useState(() => {
        return sessionStorage.getItem('language').toUpperCase();
    });
    const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

    const toggleLanguageDropdown = () => setLanguageDropdownOpen(!languageDropdownOpen);

    const navigate = useNavigate();

    const logOut = () => {
        sessionStorage.clear();
        navigate("/login");
    };
    const handleEmailSubmit = async (e) => {
        e.preventDefault()

        setErrors((prevErrors) => ({
            ...prevErrors,
            email: formDetails.email === "" ? "This field is required" : "",
        }));

        if (formDetails.email === "") {
            return;
        }
        const requestBody = {
            username: sessionStorage.getItem("username"),
            newEmail: formDetails.email,
        };
        try {
            const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage

            const result = await apiRequest('/api/users/editEmail', 'POST', requestBody, token);

            console.log("Email changed successfully:", result);
            if (result != true) {
                throw new Error(`Error: ${result}`);
            }

            sessionStorage.setItem("email", formDetails.email);
            setEmailChangeSuccess(true);
            setTimeout(() => setEmailChangeSuccess(false), 2000);
        } catch (error) {
            console.error("Error creating reservation:", error);
            setFormDetails({
                ...formDetails,
                email: "",
            });
            try {
                const parsedError = JSON.parse(error.message);

                // Check if the error body contains the expected message
                if (parsedError.Body && parsedError.Body.error) {
                    if (parsedError.Body.error.includes('Invalid email')) {

                        setErrors({
                            ...errors,
                            email: "Invalid email format",
                        });
                    }
                }
                else {
                    setFormDetails({
                        ...formDetails,
                        email: parsedError
                    });
                }
            } catch (e) {
                // If the error is not in expected format, just log it
                console.error('Unexpected error format:', error);
            }
        }
    };
    const [passwordChangeSuccess, setpasswordChangeSuccess] = useState(false);
    const handlePasswordSubmit = async (e) => {
        e.preventDefault()

        const newErrors = {
            newpassword: formDetails.newpassword === "" ? "This field is required" : "",
            oldpassword: formDetails.oldpassword === "" ? "This field is required" : "",
        };

        // Update the state with errors
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...newErrors,
        }));

        if (newErrors.newpassword || newErrors.oldpassword) {
            return;
        }

        const requestBody = {
            username: sessionStorage.getItem("username"),
            newPassword: formDetails.newpassword,
            oldPassword: formDetails.oldpassword,
        };
        try {
            const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
            const result = await apiRequest('/api/users/editPassword', 'POST', requestBody, token);

            if (result != true) {
                throw new Error(`Error: ${result}`);
            }
            console.log("Password changed successfully:", result);
            setFormDetails({
                ...formDetails,
                newpassword: "",
                oldpassword: "",
            });
            setpasswordChangeSuccess(true);
            setTimeout(() => setpasswordChangeSuccess(false), 2000);

        } catch (error) {
            console.error("Error creating reservation:", error);
            setFormDetails({
                ...formDetails,
                newpassword: "",
                oldpassword: "",
            });
            try {
                const parsedError = JSON.parse(error.message);

                // Check if the error body contains the expected message
                if (parsedError.Body && parsedError.Body.error) {
                    if (parsedError.Body.error.includes('Invalid old password')) {

                        setErrors({
                            ...errors,
                            newpassword: "",
                            oldpassword: "Invalid old password",
                        });
                    }
                }
                else {
                    setFormDetails({
                        ...formDetails,
                        oldpassword: parsedError
                    });
                }
            } catch (e) {
                // If the error is not in expected format, just log it
                console.error('Unexpected error format:', error);
            }
        }
    };
    useEffect(() => {
        const updateLanguage = async () => {
            try {
                const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from sessionStorage
                const result = await apiRequest(
                    `/api/users/editLanguage?language=${selectedEmailLanguage.toLowerCase()}`,
                    'POST',
                    null,
                    token
                );

                if (result !== true) {
                    throw new Error(`Error: ${result}`);
                }
                sessionStorage.setItem("language", selectedEmailLanguage.toLowerCase());
            } catch (error) {
                alert(`Failed to update language: ${error.message}`);
            }
        };

        if (selectedEmailLanguage) {
            updateLanguage();
        }
    }, [selectedEmailLanguage]);



    const handleInputChange = (e, field) => {
        const { name, value } = e.target;

        formDetails[name] = value;

        setFormDetails({ ...formDetails });
    };
    return (
        <React.Fragment>
            <Modal
                isOpen={modalOpen}
                toggle={toggleModal}
                centered

                className="custom-model"
            >
                <ModalBody className="pt-2">
                    <div className="row justify-content-end ">
                        <div className="col-md-2 d-flex justify-content-end pt-2 ">
                            <button type="button" className="btn-close" onClick={toggleModal} />
                        </div>
                    </div>
                    <Form>
                        <div className="row justify-content-center mb-2 mt-2">
                            <div className="col-md-8 d-flex align-items-center justify-content-start">
                                <Label className="label mb-0 me-3">
                                    {selectedLanguage === "EN" ? "Email Language" : "Email jezik"}
                                </Label>
                                <Dropdown isOpen={languageDropdownOpen} toggle={toggleLanguageDropdown}>
                                    <DropdownToggle
                                        caret
                                        style={{
                                            backgroundColor: 'transparent',
                                            color: 'rgba(13, 48, 114, 1)',
                                            border: '2px solid rgba(13, 48, 114, 1)',
                                            padding: '2px 15px',
                                            borderRadius: '5px',
                                            fontFamily: 'jura-light'
                                        }}
                                    >
                                        {selectedEmailLanguage}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem style={{ color: 'rgba(13, 48, 114, 1)', fontFamily: 'jura-light' }} onClick={() => setSelectedEmailLanguage('EN')}>EN</DropdownItem>
                                        <DropdownItem style={{ color: 'rgba(13, 48, 114, 1)', fontFamily: 'jura-light' }} onClick={() => setSelectedEmailLanguage('RS')}>RS</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <hr className='hr w-100' />
                            </div>
                        </div>
                        <div className="row justify-content-center mb-2 mt-2">
                            <div className="col-md-8">
                                <FormGroup>
                                    <Label className='label' >
                                        Email
                                    </Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        value={formDetails.email}
                                        onChange={handleInputChange}
                                        placeholder={errors.email}
                                        className={errors.email ? "input-error" : ""}
                                    />
                                </FormGroup>
                            </div>
                        </div>
                        <FormGroup>
                            <div className="row justify-content-center ">



                                <div className="col-md-8 text-end">
                                    <button
                                        className=" model-btn btn btn-primary rounded-2 py-1 px-5"
                                        onClick={handleEmailSubmit}
                                    >
                                        {emailChangeSuccess ? (
                                            <MdCheckCircle style={{ fontSize: "1.2rem", color: "#fff" }} />
                                        ) : (
                                            `${selectedLanguage === "EN" ? "Apply" : "Primeni"}`
                                        )}
                                    </button>
                                </div>
                            </div>
                        </FormGroup>
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <hr className='hr w-100' />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <FormGroup>
                                    <Label className='label' >
                                        {selectedLanguage === "EN" ? "Old Password" : "Stara šifra"}
                                    </Label>
                                    <Input
                                        type="text"
                                        name="oldpassword"
                                        value={formDetails.oldpassword}
                                        onChange={handleInputChange}
                                        placeholder={errors.oldpassword}
                                        className={errors.oldpassword ? "input-error" : ""}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <FormGroup>
                                    <Label className='label' >
                                        {selectedLanguage === "EN" ? "New Password" : "Nova šifra"}
                                    </Label>
                                    <Input
                                        type="text"
                                        name="newpassword"
                                        value={formDetails.newpassword}
                                        onChange={handleInputChange}
                                        placeholder={errors.newpassword}
                                        className={errors.newpassword ? "input-error" : ""}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <FormGroup>
                            <div className="row justify-content-center ">



                                <div className="col-md-8 text-end">
                                    <button
                                        className=" model-btn btn btn-primary rounded-2 py-1 px-5"
                                        onClick={handlePasswordSubmit}
                                    >
                                        {passwordChangeSuccess ? (
                                            <MdCheckCircle style={{ fontSize: "1.2rem", color: "#fff" }} />
                                        ) : (
                                            `${selectedLanguage === "EN" ? "Apply" : "Primeni"}`
                                        )}
                                    </button>
                                </div>
                            </div>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </Modal>
            <Navbar expand="xl" style={{ backgroundColor: "#0d3072", borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }} >
                <span className='ms-4 order-xl-1 order-1 d-block d-xl-none header-menu-btn' onClick={toggle} style={{ color: "#FFF", cursor: "pointer" }}>
                    <MdMenu />
                </span>

                {/* Logo - centered on mobile/tablet, left on xl */}
                {/* Logo - better centered on mobile/tablet, left on xl */}
                <NavbarBrand href="/admin/parking" className='d-flex justify-content-center justify-content-xl-start flex-grow-1 flex-xl-grow-0 order-xl-1 order-2'>
                    <img src="/assets/img/Sirius_logo_blau.jpg" className='logo' />
                </NavbarBrand>

                <div className='d-flex align-items-center order-xl-3 order-3 ms-auto ms-xl-0'>
                    <NavbarText className='user-name ms-4 mx-md-2 d-none d-lg-block'>{username}</NavbarText>
                    <Dropdown toggle={toggleDropdown} isOpen={dropDownOpen}>
                        <DropdownToggle className='avatar-container mx-3'>
                            <img src='/assets/icons/user-circle 2.png' className='avatar' />
                        </DropdownToggle>
                        <DropdownMenu container="body" className='header-dropdown-container px-3' style={{ width: "auto" }}>
                            <DropdownItem className='dropdown-btn mt-2 ' onClick={toggleModal} >
                                {selectedLanguage === "EN" ? "Edit profile" : "Uredi profil"}
                            </DropdownItem>
                            <div className="divider mx-2 mt-2 " />
                            <DropdownItem className='dropdown-btn mt-2 ' onClick={logOut}>
                                {selectedLanguage === "EN" ? "Log out" : "Odjavi se"}
                            </DropdownItem>

                            <div className='px-3 py-2 d-flex justify-content-center align-items-center' style={{ cursor: 'pointer' }}>
                                <span
                                    onClick={() => setSelectedLanguage('RS')}
                                    className={`me-2 language-selector ${selectedLanguage === 'RS' ? 'language-selected' : ''}`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    RS
                                </span>
                                <span className="language-selector">|</span>
                                <span
                                    onClick={() => setSelectedLanguage('EN')}
                                    className={`ms-2 language-selector ${selectedLanguage === 'EN' ? 'language-selected' : ''}`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    EN
                                </span>
                            </div>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <Collapse isOpen={isOpen} navbar className='order-xl-2 order-4 w-100'>
                    <Nav className="me-auto" navbar>
                        <NavItem>
                            <Link className={`nav-link mx-4 ${pathname === "/security/parking" ? "active" : ""} `} to="/security/parking">Parking</Link>
                        </NavItem>
                        <NavItem>
                            <Link className={`nav-link mx-4 ${pathname === "/security/history" ? "active" : ""} `} to="/security/history">
                                {selectedLanguage === "EN" ? "History" : "Istorija"}
                            </Link>
                        </NavItem>

                    </Nav>

                </Collapse>
            </Navbar>
        </React.Fragment>
    )
}

export default Header